export default "__VITE_ASSET__9112ce9d__"